module.exports = __webpack_public_path__ + "static/media/covid_qr_p0.16a9d18a.png";